import { useQuery } from "@tanstack/react-query";
import { validate } from "uuid";
import { getCustomer, getCustomers } from "../api";

export const useCustomers = (params) =>
	useQuery({
		queryFn: () => getCustomers(params),
		queryKey: ["customers", params],
	});

export const useCustomer = (id?: Customer["id"]) =>
	useQuery({
		queryFn: () => getCustomer(id),
		queryKey: ["customers", { id }],
		enabled: !!validate(id),
	});
